import React from 'react';
import {HashLink as Link} from "react-router-hash-link";
import BBExternalLink from "../../components/customBreachBits/accents/BBExternalLink";


export const BizInitialTourFree_Technical = {
    url: `/board/BreachRisk/Business/Report/TechData`,
    type: `tutorial`,
    user: {
        first_login: true,
        // first_time_on_page: true,
        // manager: true,
    },
    entity: {
        verified_ownership: true,
        subscription: "Business",
        subLevel: ["Free"],
        hasScores: true,
    },
    openingModal: {
        icon: null,
        heading: "Upgrade to See BreachRisk™ Technical",
        description: <div className={"text-center"}>
            <p>
                BreachRisk™ Technical is designed to enable your technical team to understand the full context of risk and to efficiently find, fix, and verify issues related to the threats that we've detected.
            </p>
            <p>
                The details of your infrastructure won't be available unless you upgrade your subscription, but you'll still find an overview of what we've found on this page.
            </p>
            <p>
                You can upgrade your service on the <Link to={`/board/settings/subscription#manageSubscription`} className={"text-white"}><u> Manage Subscription </u></Link> page.
            </p>

        </div>},
    tourSteps: {
        1: {
            step: 1,
            title: "Your Cyberspace — Attack Surface",
            placement: "bottom-right",
            content: "See what your cyberspace looks like from the attacker's perspective. Find overviews, trends, and detailed graphs below.",
            anchorEl: "#tourStepYourCyberSpace",
            scrollToElement: null,
            // element: document.getElementsByClassName("tourStepBRVulnsTable"),
            last: false,
        },
        2: {
            step: 2,
            title: "Track Trends",
            content: "See how your visible infrastructure has changed over time.",
            anchorEl: "#tourStepCyberSpaceTrends",
            placement: "top-start",
            scrollToElement: "#tourStepCyberSpaceTrendsScrollHeader",
            // element: document.getElementsByClassName("tourStepBRVulnsTable"),
            last: true,
        },

    },
    style: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        // width: 400,
        // height: 250,
        background: 'white',
        // border: '1px solid #000',
        boxShadow: 24,
        p: 4,
        // zIndex: 1502,
    }
}

